import { Phone, PhoneIncoming, PhoneOutgoing } from 'lucide-react'
import { fmtDur, callTs } from '../../lib/datetime.js'
import { EmptyState, fmtDateTime } from '../../kit'
import { CALL_ICON, CALL_LABEL, CALL_TONE, canListen } from '../../lib/phone.js'
import CallRecordingPlayer from './CallRecordingPlayer.jsx'

// The patient's telephony record. READ-ONLY here on purpose: claim / release /
// เสร็จสิ้น belong on /calls, where the missed-call queue is actually worked.
//
// ⚠️ `start_stamp` is a Bangkok-LOCAL epoch, not UTC — `callTs` subtracts 7h.
// Formatting it directly would show every call 7 hours late.


// For a missed inbound call the duration is ring/wait time, not talk time.
const durLabel = (c) => (c?.call_result === 'missed' ? 'รอสาย' : 'คุย')

export default function PhoneLogTable({ rows }) {
  const list = Array.isArray(rows) ? rows : []
  if (!list.length) return <EmptyState variant="plain" title="ไม่มีบันทึกการโทรของคนไข้รายนี้" />

  return (
    <div className="divide-y divide-slate-50">
      {list.map((c, i) => {
        const out = c.direction === 'outbound'
        const Dir = out ? PhoneOutgoing : PhoneIncoming
        const Ico = CALL_ICON[c.call_result] || Phone
        const ts = callTs(c)
        return (
          <div key={c.id ?? c.unique_id ?? i} className="flex items-center gap-3 py-2.5 text-[13.5px]">
            <span className={`w-7 h-7 rounded-lg flex items-center justify-center shrink-0 ${out ? 'bg-brand-50 text-brand-600' : 'bg-slate-100 text-slate-500'}`}>
              <Dir size={13} strokeWidth={2} />
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2 flex-wrap">
                <span className={`inline-flex items-center gap-1 font-medium ${CALL_TONE[c.call_result] || 'text-slate-600'}`}>
                  <Ico size={12.5} strokeWidth={2} />{CALL_LABEL[c.call_result] || c.call_result || '—'}
                </span>
                <span className="text-slate-400 text-[12.5px]">{out ? 'โทรออก' : 'สายเข้า'}</span>
                {Number(c.call_duration) > 0 && (
                  <span className="text-slate-400 text-[12.5px]">· {durLabel(c)} {fmtDur(c.call_duration)}</span>
                )}
              </div>
              <div className="text-[12px] text-slate-400 tabular-nums mt-0.5">
                {fmtDateTime(ts)}
              </div>
            </div>
            {canListen(c) && <CallRecordingPlayer uuid={c.unique_id} className="shrink-0 text-[12px]" />}
          </div>
        )
      })}
    </div>
  )
}

// The player lives in ./CallRecordingPlayer.jsx — shared with /calls, and worth a
// look before touching audio here: it fetches the recording into a Blob on
// purpose, because /api/call-recording now streams instead of buffering the mp3
// inside the shared Pages isolate (an Error 1102 path).
